/**
 * Anrufe — geteilte Regeln (ADR-006, ARCHITECTURE.md §10).
 *
 * Die Obergrenze steht hier und nicht nur im Server, weil die Oberfläche sie
 * VORHER kennen muss: Eine Warnung, die erst nach dem Anrufversuch erscheint,
 * kommt zu spät.
 */
/**
 * Mehr Teilnehmer trägt Mesh nicht.
 *
 * Bei Mesh sendet jedes Gerät n−1 Streams. Bei fünf Teilnehmern sind das vier
 * gleichzeitige Encodings und vier Uploads — das überfordert ein paar Jahre
 * altes Telefon und einen typischen Heim-Upload (Anf. 66). Die Zahl ist keine
 * Vorsichtsmaßnahme, sondern die Grenze des Verfahrens.
 */
export const MESH_MAX = 4;
/**
 * Was die App sagt, wenn es zu viele werden.
 *
 * Ehrlich statt beschönigend: Es wird nicht „vielleicht etwas langsamer",
 * sondern es funktioniert nicht gut. Und es steht ein Ausweg dabei — eine
 * Fehlermeldung ohne Alternative ist eine Sackgasse (Anf. 59).
 */
export const MESH_WARNUNG = `Ein Videoanruf mit mehr als ${MESH_MAX} Personen ruckelt auf älteren Geräten. ` +
    'Ein Audio-Anruf klappt auch mit mehr.';
/** Wie lange es klingelt, bevor der Anruf als verpasst gilt. */
export const KLINGELN_SEKUNDEN = 45;
/** Gültigkeit der TURN-Zugangsdaten. Kurz, weil sie pro Anruf neu ausgestellt werden. */
export const TURN_TTL_SEKUNDEN = 600;
/** Nach dieser Zeit wird ein unabgeholtes Signal weggeräumt. */
export const SIGNAL_TTL_MINUTEN = 5;
/**
 * Wie ein beendeter Anruf in der Liste steht.
 *
 * „Verpasst" und „abgelehnt" auseinanderzuhalten ist kein Detail: Das eine
 * heißt „ich war nicht da", das andere „ich wollte nicht". Wer beides gleich
 * anzeigt, erzeugt Missverständnisse in genau der Gruppe, in der sie am
 * meisten wehtun.
 */
export const END_TEXT = {
    completed: 'Beendet',
    missed: 'Verpasst',
    rejected: 'Abgelehnt',
    cancelled: 'Aufgelegt, bevor jemand ranging',
    failed: 'Verbindung fehlgeschlagen',
};
/** Dauer in Alltagssprache: „3 Min. 20 Sek." statt „00:03:20". */
export function dauerText(sekunden) {
    if (sekunden < 60)
        return `${sekunden} Sek.`;
    const min = Math.floor(sekunden / 60);
    const rest = sekunden % 60;
    return rest === 0 ? `${min} Min.` : `${min} Min. ${rest} Sek.`;
}
//# sourceMappingURL=call.js.map